import { render, staticRenderFns } from "./onCreated-editor.vue?vue&type=template&id=20e467a8&scoped=true&"
import script from "./onCreated-editor.vue?vue&type=script&lang=js&"
export * from "./onCreated-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e467a8",
  null
  
)

export default component.exports